export default {"src":"/_next/static/media/poolProgress.bdb877ae.svg","height":24,"width":24};